export default class SubcategoryController {
	constructor($root, id, { subcategoryId, onChangeSubcategory }) {
		this.$root = $root;

		this.id = id;
		this.currentSubcategoryId = subcategoryId || null;
		this.onChangeSubcategory = onChangeSubcategory || null

		this.CHANGE_SUBCATEGORY_EVENT = 'changeSubcategory';

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('Courses Subcategory Controller: Root element is not defined.');
		}

		if (!this.id) {
			throw new Error('Courses Subcategory Controller: Id is not defined.');
		}

		this.addEventListeners();
		this.setInitialSubcategory();
	}

	addEventListeners() {
		this.addChangeSubcategoryListener();

		if (this.onChangeSubcategory) {
			this.subscribe(this.CHANGE_SUBCATEGORY_EVENT, this.onChangeSubcategory);
		}
	}

	subscribe(name, callback) {
		if (!name || !callback) return;

		this.$root.addEventListener(name, callback);
	}

	dispatchEvent(name, payload = null) {
		if (!name) return;

		this.$root.dispatchEvent(new CustomEvent(name, {
			'detail': payload
		}));
	}

	setInitialSubcategory() {
		if (!this.currentSubcategoryId ||
			!this.$root.querySelector(`[data-value=${this.currentSubcategoryId}]`)
		) {
			const $subcatControl = this.$root.querySelector('[data-value]');

			if (!$subcatControl) {
				throw new Error('Courses Menu: There are no subcategory controls or data-value is not defined');
			}

			this.setSubcategory($subcatControl.dataset.value);
		}

		this.setActiveSubcategoryControl();
		this.dispatchEvent(this.CHANGE_SUBCATEGORY_EVENT, this.currentSubcategoryId);
	}

	addChangeSubcategoryListener() {
		this.$root.addEventListener('click', this.handleChangeSubcategory.bind(this));
	}

	handleChangeSubcategory(e) {
		const $target = e.target;

		if (!$target.classList.contains('subcats-list_btn')) return;

		this.setSubcategory($target.dataset.value);
		this.setActiveSubcategoryControl();
		this.dispatchEvent(this.CHANGE_SUBCATEGORY_EVENT, this.currentSubcategoryId);
	}

	setSubcategory(id) {
		this.currentSubcategoryId = id;
	}

	setActiveSubcategoryControl() {
		const $newActiveControl = this.$root.querySelector(`[data-value="${this.currentSubcategoryId}"]`);

		if (!$newActiveControl || $newActiveControl.classList.contains('-active')) return;

		const $currentActive = $newActiveControl.closest('.subcats-list')
			.querySelector('.subcats-list_btn.-active');

		if ($currentActive) {
			$currentActive.classList.remove('-active');
		}

		$newActiveControl.classList.add('-active');
	}
}